'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Fetch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _BaseAction2 = require('./BaseAction');

var _BaseAction3 = _interopRequireDefault(_BaseAction2);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _pickBy = require('lodash.pickby');
var _pick = require('lodash.pick');
var _omit = require('lodash.omit');
var _identity = require('lodash.identity');

var uuidv1 = require('uuid/v1');

/**
 * Class representing a fetch action.
 * @extends BaseAction
 */

var Fetch = exports.Fetch = function (_BaseAction) {
	_inherits(Fetch, _BaseAction);

	/**
  * Create an instance of the Fetch action.
  * @param {Object} config - The configuration for the action.
  */
	function Fetch(config) {
		_classCallCheck(this, Fetch);

		var _this = _possibleConstructorReturn(this, (Fetch.__proto__ || Object.getPrototypeOf(Fetch)).call(this, 'fetch', config));

		_this.do = function (instance) {
			var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


			// Extend fetch options
			options = _extends({}, _this.defaultOptions, options);

			// Make sure params is a raw JS object
			params = _immutable2.default.Iterable.isIterable(params) ? params.toJS() : params;

			// Validate instance key
			_this.validateInstance(instance);

			return function (dispatch) {

				// Create data object to be dispatched with actions
				var _this$config = _this.config,
				    uidField = _this$config.uidField,
				    actionSettings = _this$config.actionSettings,
				    api = _this$config.api,
				    notificationActions = _this$config.notificationActions,
				    normalizationSettings = _this$config.normalizationSettings;


				var data = { instance: instance, uidField: uidField, options: options, normalizationSettings: normalizationSettings, params: params };
				var msguid = uuidv1();

				// Call BaseAction.start with dispatch
				_this.start(dispatch, data);

				if (actionSettings !== undefined) {
					var notify = notificationActions.notify,
					    notifyDismiss = notificationActions.notifyDismiss;
					// Extend config options

					var settings = _extends({}, actionSettings.default, actionSettings.fetcher);
					//console.log(settings);
					var displayLoading = false; //(settings.loading !== undefined && settings.loading !== '')?true:false;
					var displayNotification = settings.notification !== undefined && settings.notification.type === 'notification' ? true : false;
					var displayMessage = settings.notification !== undefined && !displayNotification ? true : false;

					if (displayLoading) {
						dispatch(notify({
							id: msguid,
							title: settings.loading !== undefined ? settings.loading : 'Please wait',
							kind: 'loading'
						}));
					}

					//console.log('auto bulker action');
					var successHandler = _this.success.bind(_this, dispatch, data);
					var errorHandler = _this.error.bind(_this, dispatch, data);

					var url = settings.url;

					var activeProperty = localStorage.activeProperty !== undefined && localStorage.activeProperty !== 'undefined' ? JSON.parse(localStorage.activeProperty) : null;
					var propertycode = activeProperty !== null ? activeProperty.propertycode : null;

					if (options && options.property_id) {
						var properties = localStorage.properties !== undefined && localStorage.properties !== 'undefined' ? JSON.parse(localStorage.properties) : [];
						var overrideProperty = properties.find(function (property) {
							return property.id === options.property_id;
						});
						if (overrideProperty && overrideProperty.propertycode) {
							propertycode = overrideProperty.propertycode;
						}
					}

					if (propertycode !== null) {
						url = settings.url.replace(/#@propertycode@#/i, propertycode);
					}

					var apiparams = params;
					var additionalData = {};
					if (params && params._id !== undefined) {
						var _id = params._id;
						url = url + '/' + _id;
					} else {
						var sort_order = undefined;
						if (params && params.sort === 'descend') sort_order = 'desc';else if (params && params.sort === 'ascend') {
							sort_order = 'asc';
						}

						additionalData.filters = _pickBy(_omit(params, ['page', 'order', 'sort', 'limit' /*, 'query'*/]), _identity);
						additionalData.pagination = _pickBy(_pick(params, ['page', 'order', 'sort', 'limit' /*, 'query'*/]), _identity);
						//console.log(filters);
						//console.log(params);
						if (additionalData.pagination.page === undefined) {
							additionalData.pagination.page = 1;
						}
						if (additionalData.pagination.limit === undefined) {
							additionalData.pagination.limit = 10;
						}

						var parameters = _extends({
							page: params && params.page || 1,
							query: params && params.query || undefined,
							order: params && params.order || undefined,
							sort: sort_order || undefined,
							limit: params && params.limit || 10
						}, additionalData.filters);
						apiparams = _pickBy(parameters, _identity);

						//console.log(apiParameters);

						//apiparams = queryString.stringify(parameters);
						//const url = `${API_ROOT}/contacts/aarhotel`;
						if (options.url) {
							url = url + '/' + options.url;
						}
						//url = `${url}?${apiparams}`;
					}

					return api.get(url, { params: apiparams }).then(function (response) {
						if (displayLoading) {
							dispatch(notifyDismiss(msguid));
						}
						//successHandler(response.data.data);
						if (response.headers['x-total-count'] !== undefined) {
							additionalData.total = Number.parseInt(response.headers['x-total-count'], 10);
						} else if (response.data.summary && response.data.summary.total) {
							additionalData.total = Number.parseInt(response.data.summary.total, 10);
						}
						if (response.data.summary) {
							additionalData.summary = response.data.summary;
						}
						successHandler(response.data.data, additionalData, response.data.updates || []);

						/*if(displayNotification){
      dispatch(notify({
           title: settings.notification.title,
           message: (settings.notification.message !== undefined)?settings.notification.message:'',
           type: 'notification',
           kind: (settings.notification.kind !== undefined)?settings.notification.kind:'success'
       })); 
      }else if(displayMessage){
       dispatch(notify({
           title: (settings.notification.title !== undefined)?settings.notification.title:'',//response.data.message,
           kind: (settings.notification.kind !== undefined)?settings.notification.kind:'success'
       }));
      }*/
						return response.data;
					}).catch(function (error) {
						//console.log(`error:`, error)
						//console.log('Redux-clerk:', error.response)
						if (displayLoading) {
							dispatch(notifyDismiss(msguid));
						}
						errorHandler(error);

						if (error && error.response && error.response.status && error.response.status !== 401) {
							if (settings.error.type !== undefined && settings.error.type === 'notification') {
								dispatch(notify({
									title: settings.error.title,
									message: settings.error.message !== undefined ? settings.error.message : error.response.data.message,
									type: 'notification',
									kind: settings.error.kind !== undefined ? settings.error.kind : 'error'
								}));
							} else {
								dispatch(notify({
									title: settings.error.title !== undefined ? settings.error.title : error.response.data.message,
									kind: settings.error.kind !== undefined ? settings.error.kind : 'error'
								}));
							}
						}
					});
				} else {
					// If config.fetcher is provided, call it
					if (typeof _this.config.fetcher === 'function') {
						// Prepare BaseAction.success and BaseAction.error handlers
						// by currying with dispatch
						var success = _this.success.bind(_this, dispatch, data);
						var error = _this.error.bind(_this, dispatch, data);

						// Call fetcher
						return _this.config.fetcher(params, success, error);
					}
				}
			};
		};

		return _this;
	}

	/**
  * Default options for the fetch action.
  */


	/**
  * Generate an action creator with the provided data.
  * @param {String} instance - Instance key where changes should be applied
  * @param {Object} params - Additional params to be passed to the fetcher
  * @param {Object} options - Additional options used in the fetch action
  *
  * @returns {Function} - Returns the fetch action thunk.
  */


	return Fetch;
}(_BaseAction3.default);

Fetch.defaultOptions = {
	appendResponse: true,
	normalizeResponse: false,
	recalcTotal: false,
	property_id: null };